import { gql, TypedDocumentNode } from '@apollo/client'

import { IsAuthenticatedResult, IsAuthenticatedVariables } from './types'

export const IS_AUTHENTICATED_QUERY: TypedDocumentNode<
  IsAuthenticatedResult,
  IsAuthenticatedVariables
> = gql`
  query isAuthenticated {
    user: currentUser {
      id
    }
  }
`
